export default __webpack_public_path__ + "static/media/pot-logo.4e6c22a4.png";